import {OptionItemDto} from '../../../api/generics.ts';
import {DropdownOptionItem} from '../../../types';
import {isStringArray} from '../../../utils/type-guards.ts';

const getFilteredOptions = (
  data: DropdownOptionItem<string>[],
  search: string = '',
  limit?: number
) => {
  const result: DropdownOptionItem<string>[] = [];

  for (let i = 0; i < data.length; i += 1) {
    if (limit && result.length === limit) {
      break;
    }

    if (
      data[i].label &&
      data[i].label.toLowerCase().includes(search.trim().toLowerCase())
    ) {
      result.push(data[i]);
    }
  }

  return result;
};

const normalizeOptionsData = (
  data?: DropdownOptionItem[] | OptionItemDto<unknown>[] | string[]
): DropdownOptionItem<string>[] => {
  if (!data) return [];

  if (isStringArray(data)) return data.map((value) => ({value, label: value}));

  return data.map(normalizeOptionItem);
};

const normalizeOptionItem = (option: DropdownOptionItem | OptionItemDto<unknown>) => {
  option.value = String(option.value);
  option.label = String(option.label ?? option.value);
  return option as DropdownOptionItem<string>;
}

export const ComboboxUtils = {
  getFilteredOptions,
  normalizeOptionsData,
  normalizeOptionItem
} as const;